<template>
  <div class="symcell" @click="handleAdd">{{ to }}</div>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    }
  },
  methods: {
    handleAdd() {
      this.$emit('on-add', this.to)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './sym.scss';
</style>
